import { Fragment } from 'react'
import { SignalDot, TextLink } from '@indipia/ui-core'
import type { ShipStage } from '../../constants/ship.logic'
import { SHIP_PHOTO_LINK_RE, shipPopupLinkKind } from '../../constants/ship.logic'

/**
 * 4칸 흐름의 한 칸 — 색 점 + 짧은 문구. 점은 SignalDot label 로 글자와 병행.
 * onPhotoLink 가 있으면 문구 안의 '상차사진 N장'·'하차사진 N장' 을 글자 링크로 만든다.
 */
export function ShipStageCell({ stage, onPhotoLink }: {
  stage: ShipStage
  onPhotoLink?: (kind: 'LOAD' | 'UNLOAD') => void
}) {
  const pieces = onPhotoLink ? stage.text.split(SHIP_PHOTO_LINK_RE) : [stage.text]
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-01">
      <span style={{ fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface-2)' }}>{stage.title}</span>
      <span className="flex min-w-0 items-start gap-02">
        <span style={{ paddingTop: 3, display: 'inline-flex' }}>
          <SignalDot color={stage.tone} label={`${stage.title} ${stage.text}`} />
        </span>
        <span style={{ fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface)', overflowWrap: 'anywhere' }}>
          {pieces.map((p, i) => {
            const kind = onPhotoLink ? shipPopupLinkKind(p) : null
            return kind
              ? <TextLink key={i} onClick={() => onPhotoLink?.(kind)}>{p}</TextLink>
              : <Fragment key={i}>{p}</Fragment>
          })}
        </span>
      </span>
    </div>
  )
}
